import React from "react";

function HeroVisual() {
  return (
    <div className="hero-visual" aria-hidden="true">
      <div className="hero-visual-card">
        <svg viewBox="0 0 520 420" width="520" height="420" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="hv-bg" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="rgba(124,58,237,0.12)" />
              <stop offset="1" stopColor="rgba(14,165,233,0.1)" />
            </linearGradient>
            <linearGradient id="hv-line" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stopColor="#7c3aed" />
              <stop offset="1" stopColor="#0ea5e9" />
            </linearGradient>
            <filter id="hv-blur" x="-30%" y="-30%" width="160%" height="160%">
              <feGaussianBlur stdDeviation="20" />
            </filter>
          </defs>

          <rect x="18" y="18" width="484" height="384" rx="28" fill="url(#hv-bg)" opacity="0.85" />
          <rect
            x="28"
            y="28"
            width="464"
            height="364"
            rx="24"
            fill="#ffffff"
            stroke="rgba(15,23,42,0.08)"
          />

          <circle cx="130" cy="110" r="72" fill="rgba(124,58,237,0.12)" filter="url(#hv-blur)" />
          <circle cx="400" cy="285" r="88" fill="rgba(14,165,233,0.1)" filter="url(#hv-blur)" />

          <path
            d="M78 284 C 140 222, 196 230, 250 186 C 316 132, 362 164, 430 110"
            fill="none"
            stroke="url(#hv-line)"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <circle cx="78" cy="284" r="7" fill="#7c3aed" />
          <circle cx="250" cy="186" r="7" fill="#0ea5e9" />
          <circle cx="430" cy="110" r="7" fill="#6366f1" />

          <text
            x="56"
            y="78"
            fill="#0f172a"
            fontFamily="Syne, Outfit, system-ui, sans-serif"
            fontSize="15"
            fontWeight="700"
          >
            Gjendja e dorëzimit
          </text>

          <g opacity="0.95">
            <rect x="56" y="96" width="410" height="10" rx="5" fill="rgba(15,23,42,0.08)" />
            <rect x="56" y="122" width="320" height="10" rx="5" fill="rgba(15,23,42,0.06)" />
            <rect x="56" y="148" width="365" height="10" rx="5" fill="rgba(15,23,42,0.05)" />

            <rect
              x="56"
              y="198"
              width="190"
              height="112"
              rx="18"
              fill="#f8fafc"
              stroke="rgba(15,23,42,0.08)"
            />
            <rect x="70" y="216" width="120" height="10" rx="5" fill="rgba(15,23,42,0.1)" />
            <rect x="70" y="240" width="150" height="10" rx="5" fill="rgba(15,23,42,0.06)" />
            <rect x="70" y="264" width="90" height="10" rx="5" fill="rgba(15,23,42,0.05)" />

            <rect
              x="276"
              y="198"
              width="190"
              height="112"
              rx="18"
              fill="#f8fafc"
              stroke="rgba(15,23,42,0.08)"
            />
            <rect x="290" y="216" width="120" height="10" rx="5" fill="rgba(15,23,42,0.1)" />
            <rect x="290" y="240" width="150" height="10" rx="5" fill="rgba(15,23,42,0.06)" />
            <rect x="290" y="264" width="110" height="10" rx="5" fill="rgba(15,23,42,0.05)" />
          </g>
        </svg>
      </div>
    </div>
  );
}

export default HeroVisual;
